import { render, staticRenderFns } from "./AppReplaceList.vue?vue&type=template&id=2a1e734d&scoped=true&"
import script from "./AppReplaceList.vue?vue&type=script&lang=js&"
export * from "./AppReplaceList.vue?vue&type=script&lang=js&"
import style0 from "./AppReplaceList.vue?vue&type=style&index=0&id=2a1e734d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e734d",
  null
  
)

export default component.exports